enum AuthProvider {
	Email = 'email',
	Microsoft = 'microsoft',
	Google = 'google'
}

export default AuthProvider;
